import { render, staticRenderFns } from "./c_home_footer.vue?vue&type=template&id=4a8070f6&scoped=true"
import script from "./c_home_footer.vue?vue&type=script&lang=js"
export * from "./c_home_footer.vue?vue&type=script&lang=js"
import style0 from "./c_home_footer.vue?vue&type=style&index=0&id=4a8070f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8070f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8070f6')) {
      api.createRecord('4a8070f6', component.options)
    } else {
      api.reload('4a8070f6', component.options)
    }
    module.hot.accept("./c_home_footer.vue?vue&type=template&id=4a8070f6&scoped=true", function () {
      api.rerender('4a8070f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_home_footer.vue"
export default component.exports